
import { mapState } from 'vuex'
import { formatPrice } from '~/utils/helpers'
import analytics from '~/mixins.js/analytics'

export default {
  props: {
    specialOffer: {
      type: Object,
      required: true
    }
  },
  filters: { formatPrice },
  mixins: [analytics],
  data: () => ({
    loading: false,
    discount: 0,
    eventCategory: 'Special offer'
  }),
  mounted () {
    this.trackEvent(this.eventCategory, 'Show', this.specialOffer.diagram.name)
  },
  computed: {
    ...mapState('checkout', ['cart']),
    showSpecialOffer () {
      return this.specialOffer && this.diagram && !this.specialOfferInCart
    },
    hasDiscount () {
      return this.specialOffer.discount > 0
    },
    diagram () {
      return this.specialOffer.diagram
    },
    specialOfferInCart () {
      return this.cart.findIndex(item => item.diagram.id === this.specialOffer.diagram.id) > -1
    },
    title () {
      return this.specialOffer.title || 'Special offer for this order'
    }
  },
  methods: {
    close () {
      this.trackEvent(this.eventCategory, 'Close')
      this.$destroy()
      this.$el.parentNode.removeChild(this.$el)
    },

    async addToCart () {
      this.loading = true
      await this.$store.dispatch(
        'checkout/addDiagramToCart',
        {
          diagram: this.diagram,
          $gtag: this.$gtag,
          $matomo: this.$matomo,
          $bing: this.$bing,
          specialOffer: this.specialOffer
        }
      )
      await this.$store.dispatch('checkout/showAddedToCartModal', { diagram: this.diagram, $backend: this.$backend })
      this.trackEvent(this.eventCategory, 'Add to cart', this.specialOffer.diagram.name)
      this.loading = false
    },
    async loadDiagram () {
      this.trackEvent('Checkout modal', 'Show', this.diagram.name)
      await this.$store.dispatch(
        'checkout/setItemPreview',
        {
          visible: true,
          diagram: this.diagram,
          $backend: this.$backend
        }
      )
    }
  }

}
